import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10.25 19.25v-4.2l-3.65 2.1a1.75 1.75 0 0 1-1.325.175 1.59 1.59 0 0 1-1.05-.825 1.75 1.75 0 0 1-.175-1.325 1.6 1.6 0 0 1 .8-1.05L8.5 12 4.85 9.9a1.6 1.6 0 0 1-.8-1.063A1.78 1.78 0 0 1 4.225 7.5a1.6 1.6 0 0 1 1.05-.8 1.75 1.75 0 0 1 1.325.175l3.65 2.1V4.75q0-.725.512-1.237A1.69 1.69 0 0 1 12 3q.725 0 1.238.513.512.512.512 1.237v4.225l3.65-2.1a1.75 1.75 0 0 1 1.325-.175 1.6 1.6 0 0 1 1.05.8q.35.625.163 1.338a1.64 1.64 0 0 1-.813 1.062L15.5 12l3.65 2.125a1.6 1.6 0 0 1 .8 1.05q.175.7-.175 1.35a1.6 1.6 0 0 1-1.05.8 1.75 1.75 0 0 1-1.325-.175l-3.65-2.1v4.2q0 .725-.512 1.238A1.69 1.69 0 0 1 12 21q-.725 0-1.238-.512a1.69 1.69 0 0 1-.512-1.238" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }